import React, { useEffect } from 'react';
import {
  DeliveryMethodSelector,
  LocalShipping,
  Shop as ShopSvg,
  Heading,
  HeadingEnum,
  TextColorEnum,
} from '@desquared/wave-components-library';
import { toNumber } from 'lodash';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import isEmpty from 'lodash/isEmpty';

import { SelectedShopId } from '@/store/isAddressRegistered';
import useDeliveryServices from '@/hooks/useDeliveryServices';
import { Shop } from '@/store/shop';
import { IsFromLoginStore } from '@/store/isFromLogin';

import styles from './SelectServicePage.module.css';

//Todo: The backend returns the assets for each delivery service - It would be good to be able to use those and not the hardcoded ones below
export const getDeliveryServiceIcon = serviceId => {
  switch (serviceId) {
    case 'takeAway':
      return ShopSvg;
    case 'standard':
      return LocalShipping;
    case 'express':
      return LocalShipping;
    default:
      return ShopSvg;
  }
};

export default function SelectServicePage(props) {
  const t = useTranslations('common.asides.service_address');
  const router = useRouter();

  const {
    options,
    addressPickerStatus,
    setSelectedShop,
    setSelectedService,
    updateSelectedDeliveryService,
    selectedService,
  } = useDeliveryServices();

  const onDeliveryServiceSelection = serviceId => {
    IsFromLoginStore.update(true);
    updateSelectedDeliveryService(serviceId);
    SelectedShopId.update('');
    Shop.setSelectedShop('');
    setSelectedShop('');
    const selectedService = options.find(i => i.id === serviceId);
    setSelectedService(selectedService);
    if (selectedService?.deliversToAddress) {
      if (!isEmpty(props?.user)) {
        router.push('/address-details');
      } else {
        router.push('/guest-add-address');
      }
    } else {
      router.push('/select-store');
    }
  };
  if (!options) return null;

  return (
    <div className={styles.outerContainer}>
      <Heading
        color={TextColorEnum.Gray1}
        type={HeadingEnum.HeadingS}
        classOption={styles.title}
        style={{ fontWeight: 700 }}
      >
        {t('select_header')}
      </Heading>
      <div className={styles.paddingContainer}>
        <DeliveryMethodSelector
          selected={toNumber(addressPickerStatus)}
          options={options}
          onClick={onDeliveryServiceSelection}
        />
      </div>
    </div>
  );
}
